import { TYPES } from '../actions/types';

const initialState = {
  docs: [],
  currentDoc: null,
  loading: true,
  error: null
};

export const k3docReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TYPES.ACTION_GET_K3DOCS_SUCCESS:
      return {
        ...state,
        docs: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_K3DOCS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case TYPES.ACTION_GET_K3DOC_SUCCESS:
      return {
        ...state,
        currentDoc: payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_K3DOC_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case TYPES.ACTION_SET_K3DOCS_SUCCESS:
      var updatedDocIds = payload.map(doc => doc._id);

      return {
        ...state,
        docs: [
          ...state.docs.filter(doc => !updatedDocIds.includes(doc._id)), 
          ...payload
        ].sort((a, b) => {
          const dateA = new Date(a.updatedAt).getTime();
          const dateB = new Date(b.updatedAt).getTime();
          return dateB - dateA; // Sort descending (newest first)
        }),
        loading: false,
        error: null
      };
    case TYPES.ACTION_SET_K3DOCS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    default:
      return state;
  }
}; 